import React, { useContext, useState, useRef, useEffect } from 'react'

import { navigate } from 'gatsby'
import ReCAPTCHA from 'react-google-recaptcha'
import * as reCaptchaKey from './../../../shared/constants/reCaptcha'

import { siteUrl } from '../../../shared/utils/siteUrl'
import { pushEventData } from '../../../utils/pushEventDataLayer'

import useMediaQuery from '../../../utils/useMediaQuery'
import userSessionStorage from '../../../utils/userSessionStorage'
import { Context } from '../../../context/app-context'

import Button from '../../atoms/button/button'
import ButtonClose from '../../atoms/button-close/button-close'

import imgModalLogin from '../../../assets/images/common-modal/modal-login-image.svg'

import './modalLogin.scss'
import getUrlIdRegister from '../../../utils/getUrlIdRegister'
import { activities, TROPICALIZED } from '../../../constants/activity-constants'

 
const COUNTRY_PHONE_PREFIX = process.env.COUNTRY_PHONE_PREFIX

const WannaLogin = ({ activity }) => {
  const ACTIVITY_ID = activities[activity] || 0
  return (
    <div className="f-modalLogin-container__wannalogin">
      <p>
        Si aún no estás registrada <br /> ¡No {TROPICALIZED ? 'tenés' : 'tienes'} de
        qué preocuparte!
      </p>
      <a
        href={siteUrl + getUrlIdRegister(ACTIVITY_ID)}
        className="f-modalLogin-container__link --registrarme "
        rel="noreferrer"
        target="_blank"
        onClick={() =>
          pushEventData({
            event: 'Interacciones_Inicio_Sesion_Navidad',
            category: activity,
            label: 'Quiero registrarme',
          })
        }
      >
        Quiero Registrarme
      </a>
    </div>
  )
}
const ModalLogin = props => {
  const { close, handleSuccess, activity } = props
  const isMobile = useMediaQuery()

  const [isLoading, setIsLoading] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')
  const [data, setData] = useState({
    email: '',
    password: '',
  })
  const recaptchaRef = useRef(null)
  const session = new userSessionStorage()
  const { dispatch } = useContext(Context)

  const onSuccessLogin = () => {
    if (handleSuccess) {
      handleSuccess()
    }
  }
  const handleInputChange = event => {
    setData({
      ...data,
      [event.target.name]: event.target.value,
    })
  }

  const handleErrorMessage = message => {
    setErrorMessage(message)
    setTimeout(() => {
      setErrorMessage('')
    }, 5000)
  }

  const onSubmit = event => {
    event.preventDefault()
    if (isLoading) {
      // PREVENT MULTIPLE CALLS..
      return
    }

    let emailOrPhone = data.email ? data.email.replace(/\s+/g, '') : ''
    if (emailOrPhone === '') {
      // PREVENT EMPTY
      return
    }
    // validate if is only numbers
    if (/^\d+$/.test(emailOrPhone)) {
      emailOrPhone = COUNTRY_PHONE_PREFIX + emailOrPhone
    }
    setIsLoading(true)
    session.authLogin({
      payload: {
        email: emailOrPhone,
        password: data.password,
        captcha: recaptchaRef.current.getValue(),
      },
      handleSuccess: res => {
        session.authUserInfo({
          handleSuccess: res => {
            setIsLoading(false)
            pushEventData({
              event: 'Interacciones_Inicio_Sesion_Navidad',
              category: activity,
              label: 'Enviar',
            })

            onSuccessLogin()
          },
          handleError: res => {
            session.destroySession()
            handleErrorMessage(res.userMessage)
            setIsLoading(false)
          },
        })
      },
      handleError: res => {
        handleErrorMessage(res.userMessage)
        setIsLoading(false)
      },
      handleFinally: () => {
        recaptchaRef.current.execute()
      },
    })
  }

  useEffect(() => {
    const tokenInfo = session.getToken()
    if (tokenInfo) {
      const userInfo = session.getUserInfo()
      if (userInfo) {
        onSuccessLogin()
      } else {
        session.authUserInfo({
          handleSuccess: res => {
            onSuccessLogin()
          },
          handleError: res => {
            session.destroySession()
            setIsLoading(() => false)
          },
        })
      }
    } else {
      setIsLoading(() => false)
    }
  }, [])

  return (
    <div className="f-modalLogin-container">
      <ReCAPTCHA
        ref={recaptchaRef}
        size="invisible"
        sitekey={reCaptchaKey.key}
      />
      <div className="f-modalLogin-container__wrapper">
        <ButtonClose onClick={close} />

        <div className="--center --column">
          <figure className="f-modalLogin-container__figure">
            <img
              className="f-modalLogin-container__image"
              src={imgModalLogin}
              alt="chicas reunidas en el login"
            />
          </figure>
          {!isMobile && <WannaLogin activity={activity} />}
        </div>

        <section className="f-modalLogin-container__infoLogin">
          <h2>{TROPICALIZED ? 'Iniciá ' : 'Inicia '} sesión</h2>
          <p>
            Si ya estás registrada en NosotrasOnline,{' '}
            {TROPICALIZED ? 'ingresá' : 'ingresa'} tu usuario y contraseña.
          </p>
          <form onSubmit={onSubmit}>
            <label>Usuario: Correo / celular:</label>
            <input
              type="text"
              placeholder="correo@email.com"
              id="user"
              name="email"
              onChange={handleInputChange}
            />
            <label>Contraseña:</label>
            <input
              type="password"
              placeholder="*********"
              id="password"
              name="password"
              onChange={handleInputChange}
            />
            <a
              href={siteUrl + '/login/recuperar/'}
              className="f-modalLogin-container__link --olvide"
              target="_blank"
              onClick={() => {
                pushEventData({
                  event: 'Interacciones_Inicio_Sesion_Navidad',
                  category: activity,
                  label: 'Olvidé mi contraseña',
                })
              }}
            >
              Olvidé mi contraseña
            </a>
            {errorMessage && (
              <span className="f-errorMessage">{errorMessage}</span>
            )}

            <div className="f-modalLogin-container__infoLogin__buttons">
              <Button
                title="Enviar"
                type="submit"
                loading={isLoading}
                text={'Enviar'}
              />
              {isMobile && <WannaLogin />}
            </div>
          </form>
        </section>
      </div>
    </div>
  )
}

export default ModalLogin
